import ApiClient from '@/services/apiClient';

export default class AddressConfig {
    address;
    mask;
    gateway;
    dns;

    /**
   * Constructs a <code>AddressConfig</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AddressConfig} obj Optional instance to populate.
   * @return {module:model/AddressConfig} The populated <code>AddressConfig</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AddressConfig();
      obj.address = ApiClient.convertToType(data['address'], 'String');
      obj.mask = ApiClient.convertToType(data['mask'], 'String');
      obj.gateway = ApiClient.convertToType(data['gateway'], 'String');
      obj.dns = ApiClient.convertToType(data['dns'], 'String');
    }
    return obj;
  }
}
